import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Features } from "../components/Features";
import { FeaturedMenu } from "../components/FeaturedMenu";
import { Gallery } from "../components/Gallery";
import { Testimonials } from "../components/Testimonials";
import { Contact } from "../components/Contact";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Home() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60);
    }
  }, [location]);

  return (
    <main data-testid="home-page" className="bg-brand-cream">
      <Hero />
      <About />
      <Features />
      <FeaturedMenu />
      <Gallery />
      <Testimonials />
      <Contact />
    </main>
  );
}
